import React, { useState } from 'react'

// blockgroups
import CollapsibleTableRow from '../../../../../blockGroups/table/CollapsibleTableRow/CollapsibleTableRow.blockgroup'

// mui
import { Box, Container } from '@mui/system'
import { Typography, Paper } from '@mui/material'
import { TableRow, Table, TableBody, TableCell, TableContainer, TableHead } from '@mui/material'

// utils
import { cleanLogsData } from './JobDetailEquipmentLogs.collection.utils'

const JobDetailEquipmentLogs = ({ data = { shippingLogsForJob: [], receivingLogsForJob: [] }, loading, error }) => {

    const rows = [...cleanLogsData(data.shippingLogsForJob, data.receivingLogsForJob)]

    return (<Container maxWidth={false} disableGutters sx={{ marginTop: 8, marginBottom: 8}}>
        <Typography variant='h4'>Equipment Logs</Typography>
        <Box sx={{ width: "100%", marginTop: 2}}>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            <TableCell>Name</TableCell>
                            <TableCell align="right">Shipped</TableCell>
                            <TableCell align="right">Received</TableCell>
                            <TableCell align="right">Outstanding</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            rows.map(row => {
                                return (<CollapsibleTableRow row={row} />)
                            })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    </Container>)
}

export default JobDetailEquipmentLogs